const publicVapidKey = "BF15zCGJoE0nEkNjXBefDqeIJf7qRA7zY9OLQWJcCiu7cETJhhtfomUZfI3Rk-QLUMRE6EkOBM6Tt1dCCrkD_8A"; // ✅ Your real key

export const subscribeUserToPush = async () => {
  if (!("serviceWorker" in navigator && "PushManager" in window)) {
    console.warn("❌ Push messaging not supported in this browser.");
    return;
  }

  try {
    // 1️⃣ Register the service worker
    const register = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
    console.log("✅ Service Worker registered:", register);

    // 2️⃣ Request notification permission
    if (Notification.permission !== "granted") {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("🔒 Notification permission denied");
        return;
      }
    }

    // 3️⃣ Check if already subscribed
    let subscription = await register.pushManager.getSubscription();
    if (!subscription) {
      // 4️⃣ Subscribe if not already
      subscription = await register.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
      });
      console.log("📡 New Push Subscription:", subscription);
    } else {
      console.log("📡 Already subscribed:", subscription);
    }

    // 5️⃣ Send subscription to backend
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const res = await fetch(`${apiUrl}/api/push/subscribe`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(subscription),
    });

    if (!res.ok) {
      throw new Error(`Backend error: ${res.status}`);
    }

    const result = await res.json();
    console.log("✅ Backend response:", result);

  } catch (error) {
    console.error("❌ Subscription failed:", error);
  }
};

// 🔹 Utility function
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
